import CheckIcon from '@mui/icons-material/Check';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import SpellcheckIcon from '@mui/icons-material/Spellcheck';
import { useTheme } from '@mui/material';
import { MapStateButton } from 'components/track/MapStateButton';
import { TrackRequest, TrackRequestState } from 'models/TrackRequest';
import { useTranslation } from 'react-i18next';

export interface RequestMapButtonProps {
  request: TrackRequest;
  state: TrackRequestState;
  foundCount?: number;
  onClick?(request: TrackRequest): void;
}

export function RequestMapButton(props: RequestMapButtonProps) {
  const { request, state, foundCount, onClick } = props;
  const { t } = useTranslation();
  const isMapped = state === TrackRequestState.Mapped || state === TrackRequestState.AutoMapped;
  const theme = useTheme();

  const getButtonColor = () => {
    switch (state) {
      case TrackRequestState.FoundOne:
      case TrackRequestState.FoundMultiple:
        return 'warning';
      case TrackRequestState.AutoMapped:
      case TrackRequestState.Mapped:
        return 'primary';
      case TrackRequestState.NotFound:
      default:
        return 'error';
    }
  };

  const getTooltip = () => {
    switch (state) {
      case TrackRequestState.AutoMapped:
        return t('inPlaylistAutoMapped', 'In playlist, Automatically matched');
      case TrackRequestState.Mapped:
        return t('inPlaylist', 'In playlist');
      case TrackRequestState.FoundOne:
        return t('oneSongFoundInYourLibrary', '1 song found in your library');
      case TrackRequestState.FoundMultiple:
        return t('countSongsFoundInYourLibrary', '{{count}} songs found in your library', {
          count: foundCount,
        });
      case TrackRequestState.NotFound:
      default:
        return t('songNotFoundInYourLibrary', 'Song not found in your library');
    }
  };

  return (
    <MapStateButton
      tooltip={getTooltip()}
      color={getButtonColor()}
      filled={state === TrackRequestState.Mapped}
      onClick={() => onClick?.(request)}
    >
      {state === TrackRequestState.Mapped ? (
        <CheckIcon fontSize="small" sx={{ color: theme.palette.primary.contrastText }} />
      ) : state === TrackRequestState.AutoMapped ? (
        <SpellcheckIcon fontSize="small" />
      ) : state === TrackRequestState.NotFound ? (
        <PriorityHighIcon fontSize="small" />
      ) : foundCount ? (
        foundCount
      ) : (
        <QuestionMarkIcon fontSize="small" />
      )}
    </MapStateButton>
    // <Tooltip title={getTooltip()}>
    //   <Button
    //     sx={(theme) => ({
    //       padding: theme.spacing(0.25),
    //       minWidth: theme.spacing(3),
    //       width: theme.spacing(3),
    //       height: theme.spacing(3),
    //       borderRadius: theme.spacing(2),
    //       fontSize: 'small',
    //       lineHeight: 1,
    //       backgroundColor:
    //         state === TrackRequestState.Mapped ? theme.palette.primary.light : 'transparent',
    //     })}
    //     color={getButtonColor()}
    //     onClick={() => onClick?.(request)}
    //     variant={'outlined'}
    //   >
    //     {state === TrackRequestState.Mapped ? (
    //       <CheckIcon fontSize="small" sx={{ color: theme.palette.primary.contrastText }} />
    //     ) : state === TrackRequestState.AutoMapped ? (
    //       <SpellcheckIcon fontSize="small" />
    //     ) : state === TrackRequestState.NotFound ? (
    //       <PriorityHighIcon fontSize="small" />
    //     ) : foundCount ? (
    //       foundCount
    //     ) : (
    //       <QuestionMarkIcon fontSize="small" />
    //     )}
    //   </Button>
    // </Tooltip>
  );
}
